import '@ant-design/v5-patch-for-react-19';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.scss';

import { externalLogger } from 'src/app/logger';
import { App } from './App';
import { ErrorBoundary } from './ErrorBoundary';

externalLogger.initialize();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container is not found');
}

const root = createRoot(container);

root.render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
